import { faFlag } from '@fortawesome/free-solid-svg-icons';
import { memo } from 'react';

import { Props } from '@/pages/Timeline/components/TimelineHeader/types';
import TimelineIcon from '@/pages/Timeline/components/TimelineIcon/TimelineIcon';
import TimelineItemSubtitle from '@/pages/Timeline/components/TimelineItemSubtitle/TimelineItemSubtitle';
import Heading from '@/ui/components/Heading/Heading';

const TimelineHeader = ({ icon = faFlag, iconClassName, subtitle, title }: Props) => {
  return (
    <div className="flex items-center mb-1">
      <TimelineIcon className={iconClassName} icon={icon} />

      <div>
        <Heading value={3} text={title} />
        {subtitle && <TimelineItemSubtitle text={subtitle} />}
      </div>
    </div>
  );
};

export default memo(TimelineHeader);
